import { AdminLang } from "./i18n";

// Shamsi calendar in both languages ("9 Mehr 1405 AP" in English)
const locale = (lang: AdminLang) => (lang === "en" ? "en-US-u-ca-persian" : "fa-IR-u-ca-persian");

/** The API sends UTC dates without a zone ("2026-10-01T20:55:33"); read them as UTC. */
export function parseUtc(value: string | null | undefined): Date | null {
  if (!value) return null;
  const date = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(value) ? value : `${value}Z`);
  return Number.isNaN(date.getTime()) || date.getFullYear() < 2000 ? null : date;
}

export function formatDateTime(value: string | null | undefined, lang: AdminLang): string {
  const date = parseUtc(value);
  return date ? date.toLocaleString(locale(lang), { dateStyle: "medium", timeStyle: "short" }) : "—";
}

/** "۵ دقیقه پیش" / "5 minutes ago" */
export function timeAgo(value: string | null | undefined, lang: AdminLang): string {
  const date = parseUtc(value);
  if (!date) return "—";
  const seconds = Math.round((date.getTime() - Date.now()) / 1000);
  const format = new Intl.RelativeTimeFormat(locale(lang), { numeric: "auto" });
  const steps: [Intl.RelativeTimeFormatUnit, number][] = [
    ["year", 31536000],
    ["month", 2592000],
    ["week", 604800],
    ["day", 86400],
    ["hour", 3600],
    ["minute", 60],
  ];
  for (const [unit, size] of steps) {
    if (Math.abs(seconds) >= size) return format.format(Math.round(seconds / size), unit);
  }
  return format.format(0, "second");
}
